import * as Sentry from '@sentry/react'

export type TownSentryTags = {
  schoolName?: string
  projectName?: string
  townId?: string
  companyName?: string
}

const TAG_KEYS = ['school_name', 'project_name', 'town_id', 'company_name'] as const

/** 事業所回答画面の情報を Sentry タグに反映する */
export function syncSentryTownTags(tags: TownSentryTags | null): void {
  const scope = Sentry.getCurrentScope()

  if (!tags) {
    for (const key of TAG_KEYS) {
      scope.setTag(key, undefined)
    }
    return
  }

  scope.setTag('school_name', tags.schoolName?.trim() || undefined)
  scope.setTag('project_name', tags.projectName?.trim() || undefined)
  scope.setTag('town_id', tags.townId?.trim() || undefined)
  scope.setTag('company_name', tags.companyName?.trim() || undefined)
}
